export default [
  {
    path: "/metodist-dashboard",
    name: "metodist-main",
    component: () =>
      import("../../modules/Metodist/MetodistDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["metodist"],
    },
  },
  {
    path: "/metodist-quiz-complaints",
    name: "metodist-quiz-complaints",
    component: () =>
      import("../../modules/Metodist/QuizComplaints.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["metodist"],
    },
  },
];
